<template>
  <div class="container">
    <div class="go-back-container">
      <div class="go-back-icon" @click="$router.go(-1)">
        <i class="material-icons white--text">arrow_back_ios</i>
      </div>
    </div>
    <div class="filterLocationContainer" style v-if="currentLocation !== 'Worldwide'">
      <div class="filterLocation">
        <pre>{{currentLocation}}, </pre>
        <pre class="logo-color">with</pre>
        <img src="../../static/img/logo-purple.svg" alt="logo" height="12px" />
        <pre class="logo-color">view</pre>
      </div>
    </div>
    <!-- <toolbar @getClick="tapOnBasisOfClick" v-if="!isChild" /> -->
    <div
      :style="isChild? '': 'height: 100vh'"
      @click="$store.state.common.swichModesBG? $store.state.common.swichModesBG = false: ''"
      :class="`blur-it-${$store.state.common.swichModesBG}`"
      style="background: black; position: relative;"
    >
      <v-btn
        fab
        fixed
        style="bottom: 19em; right: 0.2em; height: 4.5em; width: 4.5em"
        @click="goToUserCurrentLoc"
      >
        <i class="material-icons">my_location</i>
      </v-btn>
      <div :style="isChild? 'height: 450px': `height: ${mapH}px`" id="map" class="div-width-100"></div>

      <!-- horizontal scroll view -->
      <div class="scroll-view" id="scroll-hor">
        <div
          :id="`image-${image.id}`"
          v-for="(image, i) in dummyPoints.photos"
          class="image-cards"
          :key="i"
        >
          <v-icon
            v-if="!isChild"
            class="fav-icon"
            @click="changeCnt(i)"
            :style="image.isLiked? {color: '#ff0000'}:{color: '#ffffff'}
           "
          >favorite</v-icon>

          <div
            :style="`borderBottom: ${selectedImg === image.id ? '2px solid rgb(189, 16, 224)' : 'none'}`"
            class="above-img"
          ></div>
          <div @click="$router.push({path:`/id/${image.id}?inapp=true`}); saveInLocatStorage(i)">
            <v-lazy-image class="main-img pointer" :src="mapViewImage(image.id,image)" />
          </div>

          <div
            v-if="!isChild"
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <div
              :style="image.uploader === 'admin'? {color: '#9b9b9b'}: 'color: #9b9b9b'"
              @click="
                   image.uploader !== 'admin'?
                  saveInLocatStorage(i): '';
                   image.uploader !== 'admin'?
                  $router.push({path: '/profile',
                     query: {
                    uploader: image.uploader,
                    profile_id: image.mediaSourceInformation.photoGrapherId,
                     selected_tab: 'checkins'
                     }}): ''"
              class="name pointer"
            >{{cropUsername(image.mediaSourceInformation.photoGrapherName)}} ©</div>

            <div
              class="dist"
              @click="image.distance.includes('--')? $modal.show('location-modal'): goToImageDetMap({
               caption: image.caption === ''? 'n': image.caption,
                image
              })"
            >
              <v-icon style="color: #9b9b9b" v-if="!fetchLocLoader" class="material-icons">near_me</v-icon>
              <i class="fa fa-spinner fa-spin fa-x fa-fw" style="color: #2c3e50" v-else></i>

              <div v-if="!fetchLocLoader" class="dist-text white--text">{{image.distance}}</div>
            </div>
          </div>

          <div style="max-width: 220px" class="caption">{{image.caption}}</div>
        </div>
      </div>
      <!-- /horizontal scroll view -->

      <div class="footer" v-if="!isChild">
        <img
          class="pointer"
          @click="goToHome(screenW > 600? false: true)"
          height="16"
          src="../../static/img/wav-icon.png"
        />
        <!--i class="material-icons" >home</i-->

        <i class="material-icons pointer" @click="goToUpload">photo_camera</i>

        <i
          class="material-icons pointer"
          v-if="!isLoggedIn"
          @click="

                    isLoggedIn?$router.push({path: '/profile',
                   query: {
                      uploader: 'user',
                   profile_Id: user.uid,
                   selected_tab: 'checkins'
                   }}):$router.push(`/login`)"
        >perm_identity</i>
        <img
          class="pointer"
          @click="
                    isLoggedIn?$router.push({path: '/profile',
                   query: {
                    uploader: 'user',
                   profile_id: user.uid,
                   selected_tab: 'checkins'
                   }}):$router.push(`/login`)"
          :src="user.photoURL"
          v-else
          style="height: 1.5em; width: 1.5em; border-radius: 100%;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import imageLinks from "../mixin/imageLinks";
import cropUsername from "../mixin/cropUsername";
import haversine from "haversine";
import { mapGetters, mapMutations } from "vuex";
import geohash from "geo-hash";
let GoogleMapsLoader = require("google-maps");
GoogleMapsLoader.KEY = "AIzaSyA2kK1nMxVgMkLx3M-hXodPolnlr29_vXs";
import configurations from "../configurations";
GoogleMapsLoader.LIBRARIES = ["places"];
GoogleMapsLoader.VERSION = "3.33";

import { getMapCenter } from "../helper/getMapCenter";
import toolbar from "./toolbar";

let vm;

export default {
  props: {
    isChild: {
      default: false
    },
    arr: {
      default: () => {
        return [];
      }
    }
  },
  mixins: [imageLinks, cropUsername],
  data() {
    return {
      userLocMarker: [],
      cluster: null,
      scrollEle: "",
      screenW: 0,
      selectedCity: "Berlin",
      isFirstTime: true,
      lastSelectedImg: "", // previous
      selectedImg: "", // current
      mapCenter: "",
      geolocation: "",
      markersArr: [],
      map: {},
      dummyPoints: {},
      limit: 120,
      currentLocation: "Worldwide",
      showTooltip: false
    };
  },
  watch: {
    "$store.state.gen.finalUserLocation": () => {
      vm.getLocation();
    },
    //
    selectedImg: {
      handler() {
        if (Object.keys(this.map).length !== 0) {
          setTimeout(() => {
            this.createMarkers(this.dummyPoints);
          }, 0);
        }
      }
    },
    "$route.query": () => {
      if (!vm.isChild) {
        vm.dummyPoints = {};
        vm.markersArr.forEach(function(marker, i) {
          marker.setMap(null);
        });
        vm.markersArr = [];
        vm.map = {};
        vm.isFirstTime = true;
        vm.$store.state.hello.filteredImagesArr = [];
        vm.swipeIndex = 0;
        let obj = JSON.parse(JSON.stringify(vm.$route.query));
        if (vm.$route.query.loc === `Worldwide`) {
          vm.$store.commit(`getElsewherePics`, {
            limit: vm.limit,
            startAt: 0,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : [obj.st],
            viewType: obj.vt === undefined ?[]:[obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo
          });
          vm.createMap();
        } else {
          // old func, berlin.
          vm.$store.commit(`getMainScreenImages`, {
            query: JSON.stringify({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["all"] : [obj.keywords],
            spotType: obj.spotType === undefined ? ["all"] : [obj.spotType],
            sortBy: obj.sortBy,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo
          });
          vm.createMap();
        }
      }
    }
    //
  },
  components: {
    toolbar
  },
  computed: {
    ...mapGetters([
      "filteredImagesArr",
      "maxPhotos",
      "isLoggedIn",
      "user",
      "profileGeolocation",
      "fetchLocLoader",
      "finalUserLocation"
    ]),
    mapH() {
      let screenH = screen.availHeight; //screen.height
      let mapH = screenH - 50 - 206;
      return mapH;
    }
  },
  methods: {
    ...mapMutations(["goToImageDetMap"]),
    tapOnBasisOfClick(mode) {
      switch (mode) {
        case "map": {
          break;
        }
        case "list": {
          vm.goToHome(false);
          break;
        }
        case "full": {
          vm.goToHome(true);
          break;
        }
        default:
          break;
      }
    },
    goToUpload() {
      if (this.$store.state.auth.isLoggedIn) {
        //alert(`0`)
        this.$router.push("/upload-0");
      } else {
        //alert(`1`)
        this.$router.push("/login");
        this.$store.commit("snackbar_alert", {
          msg:
            "Please sign-in to complete this action. It takes only a few seconds."
        });
      }
    },
    getLocation() {
      if (!this.isChild) {
        let vm = this;
        let arr = vm.dummyPoints.photos;
        if (arr[0].distance == "-- km") {
          for (let i in arr) {
            if (arr[i].hasGeohash) {
              let d1Lon = geohash.decode(vm.finalUserLocation);
              // console.log("d1Lon=>", d1Lon);
              let d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
              // console.log("d2Lon=>", arr[i]);
              let d2Lon = geohash.decode(arr[i].shareSpotLocation.geohash);
              let d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
              let distance = haversine(d1, d2).toFixed(0);
              arr[i].distance = distance + " km";
            }
          }
          vm.dummyPoints.photos = arr;
        }
      }
    },
    async changeCnt(index) {
      if (!this.$store.state.gen.isAPICalling) {
        if (!this.isLoggedIn) {
          this.$store.commit("snackbar_alert", {
            msg: "Please sign-in to like it. It takes only a few seconds."
          });
          this.$router.push("/login");
          this.saveInLocatStorage(index);
          return;
        }
        let arr = JSON.parse(localStorage.getItem("homePageImages"))
          .filteredImagesArr;
        let img = arr[index];
        if (this.isLoggedIn) {
          if (img.isLiked === false) {
            img.isLiked = true;
            img.likes++;
          } else {
            img.isLiked = false;
            img.likes--;
          }
          this.$store.commit("UPDATE_IS_API_CALLING", { val: true });
          let status = await vm.$store.dispatch("operationOnPhoto", {
            pid: img.id,
            uid: vm.user.uid,
            operation: "like",
            uploaderId: img.mediaSourceInformation.photoGrapherId,
            action: img.isLiked ? "add" : "remove"
          });
          this.$store.commit("UPDATE_IS_API_CALLING", { val: false });

          vm.dummyPoints.photos[index].isLiked = !vm.dummyPoints.photos[index]
            .isLiked;
          this.$store.state.hello.filteredImagesArr = arr;
          this.saveInLocatStorage(index);
          this.$forceUpdate();
        }
      }
    },
    goToHome(mode) {
      // console.log("GO HOME", mode);
      this.$store.state.common.isModeSwipe = mode; // true > full screen, false > list view
      for (let i in this.filteredImagesArr) {
        if (this.filteredImagesArr[i].id == this.selectedImg) {
          this.saveInLocatStorage(i);
          break;
        }
      }
      this.$router.push({
        path: "/",
        query: this.$route.query
      });
    },
    createMap() {
      if (
        this.filteredImagesArr.length === 0 &&
        Object.keys(this.dummyPoints).length === 0 &&
        !this.isChild
      ) {
        setTimeout(() => {
          this.createMap();
        }, 500);
      } else {
        if (Object.keys(this.dummyPoints).length === 0) this.dummyPoints = {};
        this.dummyPoints.photos = this.isChild
          ? this.arr
          : this.filteredImagesArr;
        // console.log({ dummy: this.dummyPoints });
        this.dummyPoints.totalPhotos = this.maxPhotos;
        let ls = JSON.parse(localStorage.getItem("homePageImages"));
        this.saveInLocatStorage(ls !== null ? ls.swipeIndex : 0);
        this.mapCenter = getMapCenter(this.dummyPoints.photos);

        vm = this;

        let mapMarkers = this.dummyPoints;

        GoogleMapsLoader.load(function(google) {
          setTimeout(() => {
            // console.log(
            //   "INITIALIZING MAP######################",
            //   document.getElementById("map")
            // );
            //

            // console.log(`MAP CENTER TO MAP: `, vm.mapCenter);
            let selected = {};
            let arr = vm.isChild ? vm.arr : vm.filteredImagesArr;
            // console.log({ ARRAY: vm.arr });
            for (let i in arr) {
              if (arr[i].id == vm.selectedImg) {
                selected = arr[i];
                // console.log("ID: ", selected);
              }
            }

            // console.log("SELECTED=>", selected);

            let center_1 = geohash.decode(selected.shareSpotLocation.geohash); //{lat: vm.mapCenter.avgLat, lng: vm.mapCenter.avgLng}
            let center = { lat: center_1.lat, lng: center_1.lon };
            // console.log({ center });
            vm.map = new google.maps.Map(document.getElementById("map"), {
              center: center, //map attributes
              scrollwheel: false,
              fullscreenControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              zoom: 14, //was 18 earlier // changes for imageDetPage
              //  minZoom: 4, //the less is the number the less one can zoom out
              // maxZoom:21,
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
              },
              styles: [
                {
                  featureType: "poi",
                  stylers: [
                    {
                      visibility: "off"
                    }
                  ]
                }
              ]
            });

            vm.createMarkers(mapMarkers);
          }, 100);

          //  console.log('MARKERS====>', markers)

          // console.log("MY MAP=>", vm.map);
        });

        // select one of the photo.
        if (vm.dummyPoints.photos.length !== 0) {
          if (JSON.parse(localStorage.getItem("homePageImages")) != null) {
            vm.selectedImg =
              vm.dummyPoints.photos[
                JSON.parse(localStorage.getItem("homePageImages")).swipeIndex
              ].id;
            setTimeout(() => {
              document
                .getElementById(`image-${vm.selectedImg}`)
                .scrollIntoView();
            }, 100);
          } else {
            if (!this.isChild) {
              vm.selectedImg = vm.dummyPoints.photos[0].id;
            }
          }
        }
      }
    },
    saveInLocatStorage(index) {
      if (!this.isChild) {
        let swipe = 0;
        if (JSON.parse(localStorage.getItem("homePageImages")) != null)
          swipe = JSON.parse(localStorage.getItem("homePageImages")).swipeIndex;
        let localStorageItem = {
          maxPhotos: this.maxPhotos,
          swipeIndex: index,
          //  swipeIndex: parseInt(swipe) < this.filteredImagesArr.length && JSON.parse(localStorage.getItem('homePageImages')) != null? swipe : 0,
          filteredImagesArr: this.filteredImagesArr,
          isModeSwipe: this.$store.state.common.isModeSwipe,
          lastSelectedQuery: this.$route.query.loc
        };
        localStorage.setItem(
          "homePageImages",
          JSON.stringify(localStorageItem)
        );
      }
    },
    createMarkers(mapMarkers) {
      let selIcon = {
        url: `../../static/img/wav-map-purple-marker.svg`, // url
        scaledSize: new google.maps.Size(60, 60) // to change size of marker icon
      };

      let lastIcon = {
        url: `../../static/img/wav-map-black-marker.svg`, // url
        scaledSize: new google.maps.Size(35, 35) // to change size of marker icon
      };

      // console.log({ MARKER_ARR: vm.markersArr });
      if (vm.markersArr.length <= mapMarkers.photos.length) {
        for (let i in mapMarkers.photos) {
          // console.log("mapMarkers", mapMarkers.photos[i], vm.markersArr.length);
          let markers = mapMarkers.photos[i];
          const contentString =
            '<div id="content">' +
            '<div id="siteNotice">' +
            "</div>" +
            '<div id="bodyContent">' +
            "<div>" +
            `<img src=${this.mapViewImage(
              markers.id,
              markers
            )} height="100px"/>` +
            "</div>" +
            "<div>" +
            `<a href=${configurations.currentDomain}/id/${markers.id}?inapp=true>Learn more</a>` +
            "</div>" +
            "</div>" +
            "</div>";
          let id = markers.id;
          let pos =
            Object.keys(markers.shareSpotLocation).length === 0
              ? { lat: 0, lng: 0 }
              : {
                  lat: geohash.decode(markers.shareSpotLocation.geohash).lat,
                  lng: geohash.decode(markers.shareSpotLocation.geohash).lon
                };
          let marker = new google.maps.Marker({
            draggable: false,
            title: "Learn more"
          });
          const infowindow = new google.maps.InfoWindow({
            content: contentString
          });
          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });
          marker.metadata = { id, pos };
          marker.addListener("click", function() {
            vm.lastSelectedImg = vm.selectedImg; // updating last selected
            vm.selectedImg = marker.metadata.id;
            // console.log("Trigger Func");
            document.getElementById(`image-${id}`).scrollIntoView();
          });
          vm.markersArr.push(marker);
          marker.addListener("onmouseover", function() {
            vm.showTooltip = true;
            console.log("Hovered", vm.showTooltip);
          });
          marker.addListener("onmouseleave", function() {
            vm.showTooltip = false;
            console.log("Hovered2", vm.showTooltip);
          });
        }
      }

      vm.markersArr.forEach((marker, mapIndex) => {
        //console.log('MARKER=>', marker)
        if (marker.map == null) {
          marker.setMap(vm.map);
          marker.setPosition(marker.metadata.pos);
          if (mapIndex === vm.markersArr.length) {
            let latlngbounds = new google.maps.LatLngBounds();
            for (let i = 0; i < vm.markersArr.length; i++) {
              // alert('FITBOUND')
              latlngbounds.extend(vm.markersArr[i]);
              /* if(i === vm.markersArr.length-1) {
                   vm.map.fitBounds(latlngbounds);
                 } */
            }
          }

          // vm.cluster.clearMarker(vm.markers)
          /* if(vm.cluster === null)
             vm.cluster = new MarkerClusterer(vm.map, vm.markers,
               {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
              /* {
                 styles:[
                   {
                     textColor: 'white',
                     height: 40,
                     width: 50,
                     url:'https://png.icons8.com/android/30/000000/speech-bubble.png',
                     objectFit: 'contain'
                   }
                 ]
               }); */
        }
        if (marker.metadata.id === vm.selectedImg) {
          marker.setIcon(selIcon);
          marker.setZIndex(10);
          // console.log("marker.metadata.pos=>", marker.metadata.pos);
          let pos = new google.maps.LatLng(marker.metadata.pos);
          vm.map.panTo(pos);
          vm.map.setCenter(marker.metadata.pos);
        } else if (marker.metadata.id === vm.lastSelectedImg) {
          marker.setIcon(lastIcon);
          marker.setZIndex(9);
        } else {
          marker.setIcon(lastIcon);
          marker.setZIndex(9);
        }
        //console.log('vm.$store.state.uploadImage_3.markers[0]', vm.$store.state.uploadImage_3.markers)
      });

      /*
                vm.markers.forEach(function(marker, i) {
                  //console.log('MARKER=>', marker) // marker.metadata.id
                  //marker.setMap(null); // destroy

                  //
                  if (vm.isFirstTime) {
                    // do nothing...
                  }
                  else {
                    if (marker.metadata.id === vm.lastSelectedImg) {
                      console.log(`destroy last selected marker: 1`, marker.metadata.id)
                      marker.setMap(null)
                      vm.markers.splice(i, 1)
                    }
                    if (marker.metadata.id === vm.selectedImg) {
                      console.log(`destory selected marker: 2`, marker.metadata.id)
                      marker.setMap(null)
                      vm.markers.splice(i, 1)
                    }
                  }
                  //
                })

                // 1
                function markerONMap(pos, id) {
                  if(id === vm.selectedImg)
                    console.log(id, '|', vm.selectedImg)
                  let icon = {
                    url: `https://png.icons8.com/material-rounded/150/${id == vm.selectedImg? 'F5A623': '000000'}/marker.png`, // url
                    scaledSize: id !== vm.selectedImg? new google.maps.Size(30, 30): new google.maps.Size(30, 30), // to change size of marker icon
                  }

                  let marker = new google.maps.Marker({
                    map: vm.map,
                    position: pos,
                    icon: icon,
                    zIndex: id == vm.selectedImg? 10: 2,
                    draggable: false//marker attributes
                  })
                  marker.metadata = {id}
                  marker.addListener('click', function() {
                    document.getElementById(`image-${id}`).scrollIntoView()
                    vm.lastSelectedImg = vm.selectedImg // updating last selected
                    vm.selectedImg = id // updating selected
                    console.log(`new last selected: `, vm.lastSelectedImg, ` | `,
                      `new selected`, vm.selectedImg)





                  })
                  vm.markers.push(marker);
                }

                /*  vm.markers.forEach(function (marker) {
                    console.log('MARKER',marker)
                  marker.setMap(null);
                }); */

      // vm.markers = []
      /* for(let p in mapMarkers.photos) {
           if(mapMarkers.photos[p].hasGeohash) {
             let decodedPos = geohash.decode(mapMarkers.photos[p].shareSpotLocation.geohash)
             let pos = {lat: decodedPos.lat, lng: decodedPos.lon}
             //markerONMap(pos, `${mapMarkers.photos[p].id}`) //

             if (vm.isFirstTime) {
               markerONMap(pos, `${mapMarkers.photos[p].id}`) // calling - 1
             }
             else {
               //
               console.log('P=>', vm.lastSelectedImg, '   === ', vm.selectedImg)
               if (mapMarkers.photos[p].id === vm.lastSelectedImg) {
                 console.log(`making black marker | last selected `, vm.lastSelectedImg)
                 // black icon
                 markerONMap(pos, `${mapMarkers.photos[p].id}`)
               }
               else if (mapMarkers.photos[p].id === vm.selectedImg) { // green icon
                 console.log(`making green marker | selected `, vm.selectedImg)
                 markerONMap(pos, `${mapMarkers.photos[p].id}`)
               }
             }
           }
         }
         //
         if (vm.isFirstTime) {
           vm.isFirstTime = false
           let bounds = new google.maps.LatLngBounds();
           for (let i = 0; i < vm.markers.length; i++) {
             bounds.extend(vm.markers[i].getPosition());
           }
           vm.map.fitBounds(bounds);
         }
         //
         console.log('MARKER LENGTH =>', vm.markers.length)
         vm.$forceUpdate()
         */
    },

    //
    handleScroll2() {
      // console.log(`Calling....`, this.scrollEle.scrollLeft);
      //
      let actualScroll = this.scrollEle.scrollLeft;
      //
      let sizeOfEach = 208; //228
      let n = parseInt(actualScroll / sizeOfEach);
      //
      // console.log(`select this: `, n);
      //
      this.lastSelectedImg = this.selectedImg;
      let arr = vm.isChild ? vm.arr : this.filteredImagesArr;
      if (arr[n] != undefined) {
        this.selectedImg = arr[n].id;
      }
      //
    },
    goToUserCurrentLoc() {
      if (localStorage.getItem("isLocationEnabled") == null) {
        localStorage.setItem("isLocationEnabled", "y");
      }
      let setMapToCurrentLoc = () => {
        if (this.$store.state.gen.finalUserLocation !== "") {
          let lat = geohash.decode(this.$store.state.gen.finalUserLocation).lat;
          let lng = geohash.decode(this.$store.state.gen.finalUserLocation).lon;
          let latlng = new google.maps.LatLng(lat, lng);
          vm.map.setOptions({
            center: latlng
          });
          this.userLocMarker.forEach(marker => {
            marker.setMap(null);
          });
          let marker = new google.maps.Marker({
            position: latlng,
            map: vm.map
          });
          this.userLocMarker.push(marker);
        }
      };

      if (this.$store.state.gen.finalUserLocation === "") {
        this.$store.commit("getLocationFinal");
        if (this.$store.state.common.fetchLocLoader) {
          setTimeout(() => {
            this.goToUserCurrentLoc();
          }, 10);
        } else {
          setMapToCurrentLoc();
        }
      } else {
        setMapToCurrentLoc();
      }
    }
  },
  created() {
    vm = this;
    vm.currentLocation = vm.$route.query.loc;

    if (!this.isChild) {
      vm.$forceUpdate();
      this.$store.state.hello.filteredImagesArr = [];
      // this.$store.state.uploadImage_3.markers.setMap(null)
      if (
        JSON.parse(localStorage.getItem("homePageImages")) != null 
        // &&
        // this.$store.state.hello.filteredImagesArr.length >=
        //   this.$store.state.hello.maxPhotos
      ) {
        this.$store.state.hello.filteredImagesArr = JSON.parse(
          localStorage.getItem("homePageImages")
        ).filteredImagesArr;
        this.$store.state.hello.maxPhotos = JSON.parse(
          localStorage.getItem("homePageImages")
        ).maxPhotos;
      } else {
        this.dummyPoints = {};
        let obj = JSON.parse(JSON.stringify(vm.$route.query));
        if (this.$route.query.loc === "Worldwide") {
          vm.$store.commit(`getElsewherePics`, {
            limit: this.limit,
            startAt: 0,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : [obj.st],
            viewType: obj.vt === undefined ?[]:[obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo
          });
        } else {
          this.$store.commit(`getMainScreenImages`, {
            query: JSON.stringify({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: this.limit,
            uid: this.$store.state.auth.user.uid,
            isLoggedIn: this.$store.state.auth.isLoggedIn,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["all"] : [obj.keywords],
            spotType: obj.spotType === undefined ? ["all"] : [obj.spotType],
            sortBy: obj.sortBy,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo
          });
        }
      }
    } else {
      let minus = vm.arr.length > 50 ? 50 : vm.arr.length - 1; // 50 is limit basically
      vm.selectedImg = vm.arr[vm.arr.length - minus].id;
    }
    this.createMap();
  },
  //
  mounted() {
    this.$store.commit("getLocationFinal");
    //
    setTimeout(() => {
      this.screenW = screen.width;
      //

      //
    }, 100);
    //
    //
    setTimeout(() => {
      this.scrollEle = document.getElementById("scroll-hor");
      this.scrollEle.addEventListener("scroll", this.handleScroll2);
    }, 10);
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/mixins.scss";

.go-back-container {
  cursor: pointer;
  position: fixed;
  background-color: #000000;
  z-index: 5;
  padding: 5px 0px 0px 10px;
  display: flex;
  border-radius: 50%;
  top: 20px;
  left: 15px;
}
.filterLocationContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 20px;
  z-index: 1;
  .filterLocation {
    .logo-color {
      color: $logo-color;
      font-weight: bolder;
    }
    padding: 0.3125em 0.9375em;
    background-color: rgba(0, 0, 0, 0.8);
    color: $font-color-3;
    border-radius: 4px;
    display: flex;
    align-items: baseline;
    cursor: pointer;
    @media only screen and (min-width: 768px) {
      @include fontSize(1em);
    }
    font-size: 0.75em;
    font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
      "Helvetica Neue", sans-serif !important;
    .spotTypeOthers {
      font-weight: bold;
    }
  }
}
#map {
  background: #eeeeee !important;
  width: 100vw;
  //height: 66vh;
  height: 100px;
  z-index: 1;
}
.v-lazy-image {
  filter: blur(5px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
.scroll-view {
  background: black;
  //background: green;
  overflow-y: hidden;
  overflow-x: auto;
  display: flex;
  //position: fixed;
  //height: 28vh;
  height: 206px;
  width: 100vw;
  bottom: 0;
  z-index: 2;
  //background: #ffffff;
  //padding-bottom: 10px;

  .image-cards {
    height: 100%;
    //border: 1px solid crimson;
    //min-width: 240px;
    position: relative;
    z-index: 1;

    .fav-icon {
      position: absolute;
      z-index: 2;
      top: 22px;
      opacity: 0.8;
      right: 8px;
    }

    .above-img {
      //height: 10%;
      height: 16px;
      //margin-left: 10%;
      //border-radius: 2px;
      margin-left: 13px;
      width: 215px;
    }

    .main-img {
      height: 128px;
      //height: 66%;
      //
      //border-bottom-left-radius: 2px;
      //border-bottom-right-radius: 2px;
      //
      //height: 14vh; // height of image.
      width: 215px;
      //height: 130px;
      //width: 90%;
      //margin-left: 10%;
      margin-left: 13px;
      //margin-top: 28px;
      object-fit: cover;
    }

    .name {
      text-align: left;
      margin-left: 13px;
      //font-size: 0.875em!important;
      color: #000000;
      text-transform: capitalize;
      //font-weight: 700;
      // font-family: RobotoSlab-Regular!important;
      font-size: 0.909em;
    }

    .dist {
      display: flex;
      align-items: center;

      i {
        font-size: 0.8em;
      }

      div.dist-text {
        margin-left: 2px;
        text-align: right;
        //margin-left: 10%;
        //font-size: 0.875em!important;
        color: #000000;
        //font-weight: 700;
        // font-family: RobotoSlab-Regular!important;
        font-size: 0.786em;
      }
    }

    .caption {
      text-align: left;
      margin-left: 13px;
      //font-size: 1.2em!important;
      color: #000000;
      text-transform: capitalize;
      font-weight: 700;
      // font-family: RobotoSlab-Bold!important;
      font-size: 0.857em;
      opacity: 0.8;
    }
  }
}

.footer {
  background: black;
  //background: pink;
  //background: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.61) 62%);
  //height: 18.740629685157423vh;
  //height: 6vh;
  height: 50px;
  z-index: 8;
  width: 100%;
  //position: fixed;
  //position: absolute;
  //bottom: 0;
  display: flex;
  //align-items: flex-end;
  justify-content: space-between;
  //padding-bottom: 3.7481259370314843vh;
  //padding-bottom: 20px;
  padding: 0 1.786em;
  align-items: baseline;
  i {
    margin-top: 0.5em;
    color: #9b9b9b;
    font-size: 1.5em;
  }
}

.blur-it-true {
  top: 0;
  position: fixed;
  filter: blur(3px);
  transform: scale(1);
  width: 100vw;
  overflow: hidden;
  z-index: 2;
}

.blur-it-false {
  top: 0;
  position: fixed;
  filter: blur(0px);
  transform: scale(1);
}

.container {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// mapView.vue?05dc78f2